import React from 'react';

export default function UrgencyLabel({ mode = 'icon', value, text }) {
	const urgencyColors = {
		critical: {
			color: '#E31B54',
			backgroundColor: '#FFF1F3',
			backgroundColorIcon: '#F63D68',
			borderColor: '#FFF1F3'
		},
		high: {
			color: '#B54708',
			backgroundColor: '#FFFAEB',
			backgroundColorIcon: '#FDB022',
			borderColor: '#FFFAEB'
		},
		follow_up: {
			color: '#0EA688',
			backgroundColor: '#E8FAF6',
			backgroundColorIcon: '#27E3BD',
			borderColor: '#E8FAF6'
		},
		proactive: {
			color: '#717680',
			backgroundColor: '#FFFFFF',
			backgroundColorIcon: '#F5F5F5',
			borderColor: '#F5F5F5'
		}
	};

	return (
		<div
			data-tooltip={`Urgency: ${text}`}
			className={`urgency-label ul-${mode} ${mode === 'icon' ? 'tooltip is-tooltip-right' : ''}`}
			style={{
				color: urgencyColors[value].color,
				backgroundColor:
					mode === 'icon'
						? urgencyColors[value].backgroundColorIcon
						: urgencyColors[value].backgroundColor,
				borderColor: urgencyColors[value].borderColor
			}}>
			{mode === 'text' ? text : null}
		</div>
	);
}
